import { Button, message } from "antd";
import { useEffect, useState } from "react";
import StepCard from "../ui/StepCard";
import { Card, ListItem } from "./SectionOne.default";
import CompletedStageCard from "../ui/CompletedStageCard";

const awarnessStageStepCards: Card[] = [
  {
    count: 1,
    status: "completed",
    title: "ORGANIZATIONAL AUDIT & READINESS ASSESTMENT",
    listTitle: "Complete the Organizational Readiness:",
    checkList: (
      <>
        <li>
          Review the list of potential workplace challenges under the Checklist
          section.
        </li>
        <li>
          Select all issues relevant to your organization by ticking the
          checkboxes or filling in the information.
        </li>
        <li>
          Hover over each checklist item to view additional details and examples
          (e.g., what constitutes high absenteeism or poor employee engagement).
        </li>
        <li>Click Save Selections to store your responses</li>
        <li>
          You may not edit your Checklist. If you wish to change your responses,
          please start a new form by clicking "START".
        </li>
      </>
    ),
    backgroundColor: "#cf5443",
    actions: [
      {
        name: "start new",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
      {
        name: "send",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 2,
    status: "completed",
    title: "PROBLEM RECOGNITION (ASSESTMENT)",
    listTitle: "Complete the Checklist Problem Recognition:",
    checkList: (
      <>
        <li>
          Review the list of potential workplace challenges under the Checklist
          section.
        </li>
        <li>
          Select all issues relevant to your organization by ticking the
          checkboxes or filling in the information.
        </li>
        <li>
          Hover over each checklist item to view additional details and examples
          (e.g., what constitutes high absenteeism or poor employee engagement).
        </li>
        <li>Click Save Selections to store your responses</li>
        <li>
          You may not edit your Checklist. If you wish to change your responses,
          please start a new form by clicking "START".
        </li>
      </>
    ),
    backgroundColor: "#e2a161",
    actions: [
      {
        name: "start",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 3,
    status: "completed",
    title: "ASSIGN THE 360 RISK ASSESSMENT TO EMPLOYEES",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Assign the assessment to all employees, or choose a company or
          department.
        </li>
        <li>
          The 360 Risk Assessment helps gather data on workplace stressors and
          employee well-being by evaluating factors such as workload balance,
          job control, management support, organizational culture, and personal
          well-being.
        </li>
        <li>
          This data will guide the development of well-being initiatives and
          policies.
        </li>
        <li>Click Save Selections to store your responses.</li>
        <li>
          You may not edit your Checklist. If you wish to change your responses,
          please start a new form by clicking "START".
        </li>
      </>
    ),
    backgroundColor: "#968b96",
    actions: [
      {
        name: "assign",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
];

const completedStageList: ListItem[] = [
  {
    name: "Review Your Inputs:",
    items: [
      "Visit the summary page to review all selected issues.",
      "Click Edit to make any necessary changes.",
    ],
  },
  {
    name: "Submit the Awareness Stage:",
    items: [
      "Once you’re satisfied with your inputs, click the Submit Awareness Stage button.",
      "A confirmation popup will appear. Confirm to lock your inputs and generate a final report.",
    ],
  },
  {
    name: "Post-Submission Access:",
    items: [
      "After submission, this stage will be locked for edits but will remain accessible for viewing and exporting reports.",
      "If you need to make changes after submission, contact your platform administrator to reopen the stage.",
    ],
  },
  {
    name: "Move to the Next Stage:",
    items: [
      "Upon submission, you’ll be automatically redirected to the Overview page so you may continue with stage II, Policy & Commitment Stage.",
      "NOTE: you will be able to proceed to stage II, only when at least 85% of your employees have completed their assessment and the report becomes available.",
    ],
  },
];

const completedStageTitle = "Completing the Policy & Commitment Stage";

const subTitleText = (
  <p>
    Congratulations on completing Policy & Commitment! Follow these steps to
    finalize this stage:
  </p>
);

function SectionOne() {
  const [submitActive, setSubmitActive] = useState(false);
  const [showCompletedStage, setShowCompletedStage] = useState(false);

  //Lifecycle
  useEffect(() => {
    findUncompletedSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Events
  function onSubmit() {
    setShowCompletedStage(true);
  }

  // Methods
  function findUncompletedSteps() {
    const uncompletedSteps = awarnessStageStepCards.filter(
      (step) => step.status !== "completed",
    );

    if (uncompletedSteps.length) {
      setSubmitActive(false);
    } else {
      setSubmitActive(true);
    }

    return uncompletedSteps;
  }

  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {/* Step Cards */}
      {awarnessStageStepCards.map((card) => {
        return (
          <StepCard
            key={card.count}
            countValue={card.count}
            status={card.status}
            title={card.title}
            checkListTitle={card.listTitle}
            checkList={card.checkList}
            backgroundColor={card.backgroundColor}
            actions={card.actions}
          />
        );
      })}
      {/* Submit Button */}
      <div className="flex justify-center py-8">
        <Button
          disabled={!submitActive}
          className={`bg-[#ffc107] px-16 py-8 text-lg font-bold tracking-wide ${submitActive && "hover:text-white"} `}
          onClick={onSubmit}
        >
          SUBMIT
        </Button>
      </div>
      {/* Completed Stage Component That Shows On Submmit */}
      {(showCompletedStage || submitActive) && (
        <CompletedStageCard
          title={completedStageTitle}
          subTitleText={subTitleText}
          list={completedStageList}
        />
      )}
    </section>
  );
}

export default SectionOne;
